import { render } from "./homeworkHome.vue?vue&type=template&id=546d5d83&scoped=true"
import script from "./homeworkHome.vue?vue&type=script&lang=js"
export * from "./homeworkHome.vue?vue&type=script&lang=js"

import "./homeworkHome.vue?vue&type=style&index=0&id=546d5d83&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546d5d83"]])

export default __exports__